module.exports = __webpack_public_path__ + "media/audio13.110ff863.mp3";